import { environmentBase } from './environment-base';

export const environment = {
  ...environmentBase,
  production: false,
  firebase: {
    apiKey: 'AIzaSyDU1KGqlcJ87gfuUH2aerjfhJglkbUpn1c',
    authDomain: 'aiii-developer.firebaseapp.com',
    databaseURL: 'https://aiii-developer.firebaseio.com',
    projectId: 'aiii-developer',
    storageBucket: 'aiii-developer.appspot.com',
    messagingSenderId: '700749202278',
  },
  firebaseConfig: {
    elililyhcp: {
      apiKey: 'AIzaSyARdZYUnuIVwTQ8qe23CL10cwFNsansDbw',
      authDomain: 'elilily-hcp-stage.firebaseapp.com',
      projectId: 'elilily-hcp-stage',
      storageBucket: 'elilily-hcp-stage.appspot.com',
      messagingSenderId: '868743022020',
      appId: '1:868743022020:web:af7659942924e8758e5091',
      measurementId: 'G-JT5S5R8XZD',
    },
  },
  useOtherFirebaseProject: {
    sites: ['elililyhcp'],
  },
  cloudrun: {
    ...environmentBase.cloudrun,
    api: 'https://api-v2-5uvz3vc6ga-de.a.run.app',
    survey: 'https://aiii-api-survey-5uvz3vc6ga-de.a.run.app',
    med: 'https://aiii-api-med-5uvz3vc6ga-de.a.run.app',
    video: 'https://aiii-api-video-5uvz3vc6ga-de.a.run.app',
    elililyHcpApi: 'https://stage-api.aiii.ai',
  },
  gke: {
    internalApi: 'https://stage-internal-api.aiii.ai',
    webhookApi: 'https://stage-webhook.aiii.ai',
  },
  apiKey: {
    ...environmentBase.apiKey,
    med: 'AIzaSyD5Q1-FGHUIJKMNJHY6*IKHUJYGTFRD',
  },
  ssoSignInURL:
    'https://qa.account.lilly.com/zh-TW/signin?url=https://elilily-stage.aiii.ai/sso/hcp/back?site=elililyhcp',
  elililyAwsApi: `https://qa.api-twhcpline.lilly.com/hcp-line`,
  on24RegistrationUrl: `https://seamlessreg.on24.com/`,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
